/**
 * Curated lowlight instance for syntax highlighting in code blocks.
 *
 * Only these ~15 common languages are registered (not all of highlight.js) to
 * keep the bundle small; any other ```lang fence falls back to plaintext with
 * no error. `xml` also covers HTML (highlight.js registers `html` as an alias).
 * See docs/PLAN-MARKDOWN-CODE-TABLES-FOOTNOTES.md.
 */
import {createLowlight} from 'lowlight';
import bash from 'highlight.js/lib/languages/bash';
import c from 'highlight.js/lib/languages/c';
import cpp from 'highlight.js/lib/languages/cpp';
import css from 'highlight.js/lib/languages/css';
import go from 'highlight.js/lib/languages/go';
import java from 'highlight.js/lib/languages/java';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import markdown from 'highlight.js/lib/languages/markdown';
import python from 'highlight.js/lib/languages/python';
import rust from 'highlight.js/lib/languages/rust';
import sql from 'highlight.js/lib/languages/sql';
import typescript from 'highlight.js/lib/languages/typescript';
import xml from 'highlight.js/lib/languages/xml';
import yaml from 'highlight.js/lib/languages/yaml';

export const lowlight = createLowlight();

lowlight.register({
  bash,
  c,
  cpp,
  css,
  go,
  java,
  javascript,
  json,
  markdown,
  python,
  rust,
  sql,
  typescript,
  xml,
  yaml
});
